import { getProductImageServer } from "./getProductImageServer"

/**
 * Rewrite an image URL to use a smaller image that can just fit in its container.
 * @param url
 * @param containerRect: should be the result of getBoundingClientRect(),
 *  which returns size after applying transformations
 *  so we can get real size in pixels even within ZoomLayout, so we can
 *  request right resolution and render crisp image.
 * @returns
 */
export function rewriteImageURL(
  url: string, containerRect: {width: number, height: number}, noCache?: boolean) {
  if (!url) {
    return
  }
  const { width, height } = containerRect

  // modern browsers report device pixel ratio
  const devicePixelRatio = window.devicePixelRatio || 1

  const imageOptions = calculateStyeCode(width, height, devicePixelRatio)

  return url
    .replace(/^(https?:\/\/)[^/]+/, getProductImageServer())
    // inject MSA tags into filename
    .replace(/(\.[^.]+)$/, "." + imageOptions + "$1")
    // disable caching if needed
    + (noCache ? `?ts=${Date.now()}` : "")
}

// Apply image style codes.
// See more: https://w.amazon.com/index.php/MSA/HowTo/ImageStyleCodes
function calculateStyeCode(width: number, height: number, devicePixelRatio: number) {
  // Sometimes we can't get the container's eventual client rect, like during
  // the first rendering.
  // In this case, just use the raw image.
  if (!width && !height) {
    return "_AC_"
  }
  width = Math.round(width * devicePixelRatio)
  height = Math.round(height * devicePixelRatio)
  // AC - white space auto crop, SX - scale to width, SY - scale to height
  // Assume that image is square so request size to fit into smallest side
  return (height === 0 || width < height)
    ? `_AC_SX${width}_`
    : `_AC_SY${height}_`
}
